/**
 * Scrolls smoothly to a section on the page
 * @param href - The href string (e.g., '#start', '#new-drones', '#')
 * @param options - Optional configuration
 * @param options.onComplete - Callback function to execute after scrolling
 */
export function scrollToSection(href: string, options?: { onComplete?: () => void }): void {
  const targetId = href.substring(1);
  const element = targetId ? document.getElementById(targetId) : null;

  if (href === '#start' || href === '#') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    options?.onComplete?.();
  } else if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    options?.onComplete?.();
  }
}
